import { useEffect, useState } from "react";
import "./App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import { AdminAuthCheck } from "./api/Calling";
import { ToastContainer } from "react-toastify";
import Navbar1 from "./components/Navbar/Navbar1";
import Navbar2 from "./components/Navbar/Navbar2";
import Login from "./admin/Login/Login";
import Page404 from "./components/page/Page404";
import Logout from "./admin/Login/Logout";
import Error from "./admin/Login/Error";
import Home from "./admin/Home";
import Whitelist from "./admin/Whitelist/Whitelist";
import EventTracker from "./admin/EventTracker/EventTracker";
import INSPACTLOOCK from "./components/INSPACTLOOCK";
function App() {
  const [isAuthorized, setIsAuthorized] = useState(null); // Initially null
  const navigate = useNavigate();

  const handleLoginStatusChange = (status) => {
    if (status) {
      setIsAuthorized(true);
    }
  };

  const handleLogout = () => {
    setIsAuthorized(false);
    localStorage.removeItem("admin_crypto");
    navigate("/app-admin/panel/login");
  };

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const adminToken = localStorage.getItem("admin_crypto");
        if (!adminToken) {
          setIsAuthorized(false);

          return;
        }

        const resp = await AdminAuthCheck();
        setIsAuthorized(resp.status);
      } catch (error) {
        console.log(error);
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  return (
    <div className="flex roboto-regular bg-main-bg">
      <ToastContainer />
      <INSPACTLOOCK />
      {isAuthorized && <Navbar1 />}
      <div className="flex ml-w-15 w-[100%]">
        {isAuthorized && <Navbar2 />}
        <Routes>
          {isAuthorized ? (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/admin/whitelist" element={<Whitelist />}></Route>
              <Route
                path="/Logout"
                element={<Logout onLogout={handleLogout} />}
              />
              <Route path="/admin/event-tracker" element={<EventTracker />} />

              <Route path="*" element={<Error />} />
            </>
          ) : (
            <>
              <Route
                path="/app-admin/panel/login"
                element={<Login onLogin={handleLoginStatusChange} />}
              />
              <Route path="*" element={<Page404 />} />
            </>
          )}
        </Routes>
      </div>
    </div>
  );
}

export default App;
